'use strict';

import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SwitchComponent } from './component';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports     : [
    BrowserModule,
    FormsModule
  ],
  declarations: [SwitchComponent],
  exports     : [SwitchComponent]
})
export class LKSwitch {
}
